import { useEffect } from "react";
import { useTheme } from "./contexts/NewThemeContext";

export default function TitleUpdater() {
  const { platformName } = useTheme() || {};

  useEffect(() => {
    if (platformName !== undefined) {
      document.title = platformName;
    }
  }, [platformName]);

  return null;
}
